export const TOOLBAR_OPTIONS = [[{
  header: [1, 2, 3, false]
}], [{
  direction: 'rtl'
}, {
  align: []
}], ['bold', 'italic', 'underline', 'strike', 'link'], [{
  color: []
}, {
  background: []
}], ['blockquote', 'code-block'], [{
  list: 'ordered'
}, {
  list: 'bullet'
}, {
  indent: '-1'
}, {
  indent: '+1'
}], ['clean']];
export const DIRECTION = ({
  RTL: 'rtl',
  LTR: 'ltr'
} as const);
export const RTL_LANGUAGES_REX = /[\u0600-\u06FF\u0750-\u077F]/;